<template>
  <div data-component-group="line-item-dialog" data-component="edit">
    <dialog-base
      content-class="edit-line-item-dialog"
      is-fullscreen
      :is-on="isOn"
      :on-close="onCancel"
    >
      <template v-slot:content>
        <div class="dialog-close" data-cy="nested-pop-up-close-btn">
          <v-btn
            icon
            class="trigger close-dialog elevation-0"
            @click="onCancel"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div
          data-component-group="line-item-form"
          data-component="edit"
          class="elevation-1"
        >
          <panels-line-items-hero
            :order="order"
            :line-item="lineItem"
            :is-loading="isLoading"
            :is-updating="isUpdating"
            :on-change-status="onChangeStatus"
          />
          <forms-line-add-new
            :order="order"
            :line-item="lineItem"
            :is-loading="isLoading"
            :is-loading-details="isLoadingDetails"
            :is-updating="isUpdating"
            :is-disabled="true"
            :is-on="isOn"
            :on-cancel="onCancel"
            :on-submit="onConfirm"
            :on-change-status="onChangeStatus"
            confirm-trigger-label="Update"
          />
        </div>
      </template>
    </dialog-base>
  </div>
</template>

<script>
  export default {
    props: {
      order: {
        type: Object,
        required: true,
      },
      lineItem: {
        type: Object,
        required: true,
      },
      isOn: {
        type: Boolean,
        default: false,
      },
      isLoading: {
        type: Boolean,
        required: true,
      },
      isLoadingDetails: {
        type: Boolean,
        default: false,
      },
      isUpdating: {
        type: Boolean,
        required: true,
      },
      onCancel: {
        type: Function,
        required: true,
      },
      onConfirm: {
        type: Function,
        required: true,
      },
      onChangeStatus: {
        type: Function,
        required: true,
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

.edit-line-item-dialog > .modal__backdrop > .modal__content {
  padding: 0;

  > .modal__body {
    position: relative;

    .dialog-close {
      position: absolute;
      top: $spacing-sm;
      right: 6px;
      width: auto;
      z-index: 10;
      padding: 0;

      .trigger.close-dialog {
        width: 60px;
        min-width: auto;
        height: 60px;
        border-radius: 50%;
        padding: 0;
        margin: 0;
        background-color: transparent;

        .v-icon {
          margin: 0;
          font-size: $text-size-xl + 0.5rem;
          color: map.get($colors, shades, 'white');
        }

        &:before {
          background-color: transparent;
        }
      }
    }

    [data-component='edit'] {
      padding: 0;
      width: 640px;

      .layout > .flex {
        &:nth-child(2),
        &:nth-child(3) {
          padding-left: 15px;
        }
      }
    }
  }
}

[data-component-group='line-item-form'][data-component='edit'] {
  .forecast-wrapper {
    .forecast-warning {
      margin: 0;
    }

    .forecast-data {
      margin: 0;
    }
  }
}
</style>
